module.exports = __webpack_public_path__ + "static/media/logo_biodef_colored.cdc2b984.png";